import React, { useEffect, useState } from "react";
import styles from "../App.module.css";
import { useLocation } from "react-router-dom";

function Services() {
  const [services, setServices] = useState({});
  const location = useLocation();
  const slug = location.pathname.split("/").filter(Boolean).pop();
  const baseurl = process.env.REACT_APP_API_BASE_URL;
  const getServices = async () => {
    try {
      const response = await fetch(`${baseurl}get-pages.php/${slug}`);
      const result = await response.json();
      setServices(result.data.length > 0 && result.data[0]); // Adjust based on your API response
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };
  useEffect(() => {
    getServices();
  }, []);
  return (
    <>
      <section
        id="home"
        className={`${styles.hero} ${styles.about_banner}`}
        data-aos="fade-up"
        style={{ backgroundImage: `url(${services.banner_image})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="font-bold leading-12 text-5xl">Services</h1>
              <p className="text-white text-xl font-semibold mt-2 mb-0 w-2/5">
                it is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div dangerouslySetInnerHTML={{ __html: services.description }} />
      <div class="w-1/2 px-3 d-none">
        <div class="grid grid-cols-3">
          <h6 class="font-bold flex items-center text-white uppercase border-r-2 border-yellow-400 px-3">
            Corporate brand building
          </h6>
          <h6 class="font-bold flex items-center text-zinc-500 uppercase border-r-2 border-yellow-400 px-3">
            event and exhibitions
          </h6>
          <h6 class="font-bold flex items-center text-zinc-500 uppercase px-3">
            digital branding
          </h6>
        </div>
        <div class="grid grid-cols-4">
          <h6 class="font-bold flex items-center text-zinc-500 uppercase border-r-2 border-yellow-400 px-3">
            website designing
          </h6>
          <h6 class="font-bold flex items-center text-zinc-500 uppercase border-r-2 border-yellow-400 px-3">
            interior design
          </h6>
          <h6 class="font-bold flex items-center text-zinc-500 uppercase border-r-2 border-yellow-400 px-3">
            road show
          </h6>
          <h6 class="font-bold flex items-center text-zinc-500 uppercase border-r-2 border-yellow-400 px-3">
            signage design
          </h6>
        </div>
        <div class="grid grid-cols-3">
          <h6 class="font-bold flex items-center text-zinc-500 uppercase border-r-2 border-yellow-400 px-3">
            retail showroom design
          </h6>
          <h6 class="font-bold flex items-center text-zinc-500 uppercase px-3">
            in shop activation
          </h6>
        </div>
      </div>
    </>
  );
}

export default Services;
